addEventListener('activate', event => {
    event.waitUntil(async function() {
        if (self.registration.navigationPreload) {
        // ナビゲーションのプリロードを有効にします！
            await self.registration.navigationPreload.enable();
        }
    }());
});
$(function() {
    if($('main.column-detail').length && $('iframe[src^="https://www.youtube.com"]').length) {
        $('iframe[src^="https://www.youtube.com"]').wrapAll('<div class="youtube-iframe"></div>');
        $('div.youtube-iframe').wrapAll('<div class="youtube-iframe-wrap"></div>');
    }
});

/*==================================================
ページ内リンク
==================================================*/
$(function(){
    $(document).on(oEventNames.end, 'a[href^="#"]', function(event) {
        event.preventDefault();
        if (!bIsScrolling) {
            let headerHight = $('.header').innerHeight();//ヘッダの高さ
            let href = $(this).attr("href");
            let target = $(href == "#" || href == "" ? "html" : href);
            let padding = 16;
            let position = target.offset().top - headerHight - padding; //ヘッダの高さ分位置をずらす
            $("html, body").animate({ scrollTop: position }, 1000, "swing");
            return false;
        }
    });
});


if($('#toc').length > 0){
$(function(){
    let counter = 0;
    $('.column-detail .content h2, .column-detail .content h3, .column-detail .content h4').each(function(){
        counter++;
    });
    if(counter > 1) {
    $("#toc")
        .append('<p class="index-title">目次<button type="button" class="toggle-index"></button></p><ol class="index"></ol>');
    }else {
    $('#toc').hide();
    }

    // .toc-target内にある見出し（h2, h3, h4）を、目次に入れます
    $(".column-detail .content h2, .column-detail .content h3, .column-detail .content h4").each(function(i) {
    var current = $(this);
    current.attr("id", "title" + i);
    if (current.get(0).tagName == 'H2'){
        $("#toc ol.index").append('<li class="level1"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
    }
    if (current.get(0).tagName == 'H3'){
        $("#toc ol.index").append('<li class="level2"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
    }
    if (current.get(0).tagName == 'H4'){
        $("#toc ol.index").append('<li class="level3"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
    }
    });
    $('.toggle-index').on('click', function() {
    $(this).toggleClass('show');
    $('ol.index').toggle('slow');
    });
});
}


// 目次
// if($('#toc').length > 0){
//     $(function(){
//         $('.open-modal-column-detail-toc').on(oEventNames.end, function (event) {
//             if (!bIsScrolling) {
//                 event.preventDefault();
//                 MicroModal.show('modal-column-detail-toc', {
//                     awaitCloseAnimation: true,
//                     disableScroll: true
//                 });
//             }
//         });
//         var counter = 0;
//         $('.column-detail .content h2, .column-detail .content h3, .column-detail .content h4').each(function(){
//             counter++;
//         });
//         if(counter > 1) {
//             $("#toc")
//             .append('<p class="index-title">目次</p><ol class="index"></ol>');
//         }else {
//             $('#toc').hide();
//         }

//         // .toc-target内にある見出し（h2, h3, h4）を、目次に入れます
//         $(".column-detail .content h2, .column-detail .content h3, .column-detail .content h4").each(function(i) {
//             var current = $(this);
//             current.attr("id", "title" + i);
//             if (current.get(0).tagName == 'H2'){
//                 $("#toc ol.index").append('<li class="level1"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
//             }
//             if (current.get(0).tagName == 'H3'){
//                 $("#toc ol.index").append('<li class="level2"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
//             }
//             if (current.get(0).tagName == 'H4'){
//                 $("#toc ol.index").append('<li class="level3"><a id="link' + i + '" href="#title' + i + '"><span>' + current.text() + "</span></a></li>");
//             }
//         });
//         $('.toggle-index').on('click', function() {
//             $(this).toggleClass('show');
//             // $('ol.index').slideToggle('slow');
//         });
//     });
// }